import type { FormatterArgs } from '@/services/types/formatter';

const STATUS_TEXT: Record<string, string> = {
  '1': 'Draft',
  '2': 'Moderation pending',
  '3': 'Rejected',
  '4': 'Ready',
  '6': 'Working',
  '7': 'Paused',
  '8': 'Stopped',
  '9': 'Completed',
};

const STATUS_COLOR: Record<string, string> = {
  '1': 'gray',
  '2': '#0080ff',
  '3': '#ee2b2b',
  '4': '#00b359',
  '6': '#00b359',
  '7': '#fa0',
  '8': '#fa0',
  '9': '#fa0',
};

export default ({ ctx, data, key }: FormatterArgs) => {
  if (!data[key]) return;

  if (data.DT_RowIntegrationStatus !== 'active') {
    return {
      kind: 'campaign-external-inactive',
      text: ctx.t('Not active'),
    };
  }

  const statusKey = String(data[key]);

  return {
    kind: 'campaign-external-status',
    text: STATUS_TEXT[statusKey] ?? '',
    color: STATUS_COLOR[statusKey] ?? '',
    dimmed: !ctx.$PL.integrationPropellerads,
    helpText: ctx.t('To update the statuses BeMob is synced with the source every 5 min.'),
  };
};
